export default "__VITE_ASSET__c241d991__"